import { DemoProvider } from '@/context/DemoContext';
import AdminPage from '@/components/AdminPage';
import DemoBanner from '@/components/DemoBanner';
import SEOHead from '@/components/SEOHead';

/**
 * Public, read-only* sales preview of the admin panel.
 * (* writes are simulated against in-memory fixtures and reset on refresh)
 *
 * The DemoProvider patches window.fetch so all real Admin components
 * run unmodified against canned data.
 */
export default function AdminDemoPage() {
  return (
    <DemoProvider>
      <SEOHead
        title="Live Admin Panel Demo · UI DESIGNS"
        description="Explore the SaaS admin panel that comes with every UI Designs Care Plan. Edit content, view analytics, manage products and orders — all in one place."
        canonical="https://uidesigns.co.uk/admin-demo"
        keywords="admin panel demo, website CMS demo, web design Bournemouth"
      />
      <DemoBanner />
      <AdminPage />
    </DemoProvider>
  );
}
